
  import {  CLOSING_MANAGER_DETAILS, CLOSING_MANAGER_LIST } from "../types";
  
  const initialState = {
    response: null,
    loading: true,
    create: false,
    detail: false,
    update:false,
  };

  
  export default function closingManagerStore(state = initialState, action) {
    switch (action.type) {
      case CLOSING_MANAGER_LIST:
        return {
          ...state,
          loading: false,
          create: false,
          detail: false,
          response: action.payload,
        };
        case CLOSING_MANAGER_DETAILS:
          return {
            ...state,
            loading: false,
            create: false,
            detail: true,
            response: action.payload,
          };
      default:
        return state;
    }
  }